var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3564 9.43555C10.6999 9.43555 10.2332 9.71274 10.2332 10.1212V15.6792C10.2332 16.0293 10.7 16.3794 11.3564 16.3794C11.9837 16.3794 12.4943 16.0293 12.4943 15.6792V10.1212C12.4943 9.71274 11.9837 9.43555 11.3564 9.43555Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3564 6.00586C10.6853 6.00586 10.1602 6.48726 10.1602 7.0416C10.1602 7.59594 10.6853 8.09195 11.3564 8.09195C12.0129 8.09195 12.5381 7.59594 12.5381 7.0416C12.5381 6.48731 12.0128 6.00586 11.3564 6.00586Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3563 0C5.07924 0 0 5.07666 0 11.3497C0 16.472 3.37245 20.7251 7.91929 22.1696L10.5019 25.9764C10.694 26.2596 11.014 26.4291 11.3563 26.4291C11.6985 26.4291 12.0185 26.2596 12.2106 25.9764L14.7932 22.1696C19.3421 20.7245 22.7125 16.4697 22.7125 11.3497C22.7125 5.07269 17.6292 0 11.3563 0ZM13.8673 20.2915C13.6322 20.3573 13.428 20.5042 13.291 20.7062L11.3563 23.5578L9.42162 20.7062C9.28452 20.5042 9.08037 20.3573 8.84524 20.2916C4.97492 19.2094 2.06478 15.65 2.06478 11.3497C2.06478 6.22994 6.23294 2.06478 11.3563 2.06478C16.4796 2.06478 20.6478 6.22994 20.6478 11.3497C20.6478 15.6543 17.7333 19.2106 13.8673 20.2915Z",
    fill: "#FF0000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelperIcon);
export default __webpack_public_path__ + "static/media/helperIcon.5a11a81e.svg";
export { ForwardRef as ReactComponent };